import {Auth} from '@aws-amplify/auth'
import {API} from '@aws-amplify/api'
import {Signer} from '@aws-amplify/core'
import {getApiMetadata, makeApiClient, makeApiGatewayClient} from '@peachy/core-domain-client'
import {DocGenApi, DocGenApiDefinition} from '@peachy/doc-gen-pure'
import {ClaimsActivityApiDefinition} from '@peachy/claims-activity-pure'
import {FlashRepoApiDefinition} from '@peachy/flash-repo-pure'
import {UserAdminApiGatewayDefinition} from '@peachy/web-dashboard-pure'
import {createGeoLocationServiceClient} from '@peachy/geo-location-client'
import {ILambdaApiProvider} from './ILambdaApiProvider'

export class LambdaApiProvider implements ILambdaApiProvider {

    constructor(
        readonly servicePatchUri: string,
        readonly api: typeof API,
        readonly auth: typeof Auth,
        readonly signer: typeof Signer
        ) {
    }

    async docApi() {
        const client: DocGenApi = await makeApiClient(DocGenApiDefinition, this.servicePatchUri, this.signer, this.auth)

        return {
            ...client,
            getPdfLink(ticketId: string, asFile: string) {
                const routes = getApiMetadata(client).routes
                return `${routes.renderPdfTicket}/${asFile}?ticketId=${ticketId}`
            }
        }
    }

    async claimsActivityApi() {
        return makeApiClient(ClaimsActivityApiDefinition, this.servicePatchUri, this.signer, this.auth)
    }

    async adminRepoApi() {
        return makeApiClient(FlashRepoApiDefinition, this.servicePatchUri, this.signer, this.auth)
    }

    async userAdminApi() {
        return makeApiGatewayClient(UserAdminApiGatewayDefinition, this.api, this.auth)
    }

    geoLocationApi() {
        return createGeoLocationServiceClient(this.servicePatchUri, this.signer)
    }

}
